import { Window } from './Window';

export const WindowHost = Window.Host;
